module.exports = __webpack_public_path__ + "static/cf-med-italic-93c8c41d2c204af3894a18a00e5773ad.ttf";